import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";
import useScreenDimensions from "../hooks/useScreenDimensions";

import { create } from "zustand";

interface BasicState {
  isOpen: boolean;
  setIsOpen: (newVal: boolean) => void;
  title: string;
  setTitle: (newVal: string) => void;
  body: string;
  setBody: (newVal: string) => void;
  activateModal: (title: string, body: string) => void;
}

export const useGeneralModal = create<BasicState>((set) => ({
  isOpen: false,
  setIsOpen: (newVal: boolean) => set({ isOpen: newVal }),
  title: "",
  setTitle: (newVal: string) => set({ title: newVal }),
  body: "",
  setBody: (newVal: string) => set({ body: newVal }),
  activateModal: (title: string, body: string) => {
    set({ isOpen: true, title: title, body: body });
  },
}));

export const GeneralModal = () => {
  const isOpen = useGeneralModal((state) => state.isOpen);
  const setIsOpen = useGeneralModal((state) => state.setIsOpen);
  const { width, height } = useScreenDimensions();

  const cancelEvent = (e: React.MouseEvent) => e.stopPropagation();

  const closeModal = () => {
    setIsOpen(false);
  };

  const title = useGeneralModal((state) => state.title);
  const body = useGeneralModal((state) => state.body);

  return (
    <AnimatePresence>
      {isOpen ? (
        <motion.div
          key={"campaignModal"}
          style={{
            width,
            height,
            backgroundColor: "rgba(0, 0, 0, .3)",
            position: "fixed",
            zIndex: 9999999999999999999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
          }}
          onClick={closeModal}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
        >
          <div
            onClick={cancelEvent}
            style={{
              width: "40rem",
              minWidth: 400,
              backgroundColor: "white",
              padding: 24,
              borderRadius: 16,
              opacity: 1,
            }}
          >
            <div
              style={{
                fontWeight: 500,
                fontSize: "2rem",
                marginBottom: "1rem",
              }}
            >
              {title}
            </div>
            <div style={{ marginBottom: ".5rem" }}>{body}</div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
